import React, { Component } from 'react';
import './App.css';

import Eng from './localization/course_en.json';
import Kor from './localization/course_kor.json';
import Rus from './localization/course_rus.json';
import Chn from './localization/course_chn.json';
import Ger from './localization/course_ger.json';
import Fra from './localization/course_fra.json';
import Ita from './localization/course_ita.json';
import Jap from './localization/course_jap.json';
import Bra from './localization/course_bra.json';
import Esp from './localization/course_esp.json';

import config from './config.json';

export default class App extends Component {

  constructor(props){
    super(props);

    this.state = {
      lang:"",
      quiz:"",
      ready:false,
      index:0,
      selected:[],
      stack:[]
    }

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.start = this.start.bind(this);
    this.reset = this.reset.bind(this);
  }

  componentDidMount() {

  }

  start(){

    if(this.state.lang === ""){
      this.setState({
        lang:"en",
        ready:true,
        quiz:this.shuffle(Eng.questions),
      })
    }else if(this.state.lang != "") {
      this.setState({
        ready:true,
      })
    }
  }



  handleSubmit() {

    if(this.state.selected.length === 0){
      return;
    }

    let ac = this.state.selected.sort((a, b) => a - b);
    let stack = this.state.stack;
    stack.splice(this.state.index, 1, ac);
    if(ac.toString() === this.getCC(this.state.index).toString()) {

      this.setState({
        index:this.state.index + 1,
        stack:stack,
        selected:[]
      });
    }
    else {
      this.setState({
        index:this.state.index + 1,
        stack:stack,
        selected:[]
      });
    }
  }

  getCC = (index) => {
    // Get correct code
    let cc = [];
    for(let i = 0; i < this.state.quiz[index].body.length; i++){
      if(this.state.quiz[index].body[i].correct === true){
        cc.push(i);
      }
    }

    return cc;
  }

  getScore = () => {
    let score = 0;
    for(let i = 0; i < this.state.stack.length; i++){

      if(this.state.stack[i].toString() === this.getCC(i).toString()){
        score++;
      }
    }

    return score;
  }


  handleClick(elem) {

    if(this.state.quiz[this.state.index].type === "checkbox"){
      let a = this.state.selected;
      if(a.includes(elem.key)){
        const i = a.indexOf(elem.key);
        a.splice(i,1);
      }else {
        a.push(elem.key);
      }

      this.setState({
        selected:a
      });
    } else {
      this.setState({
        selected:[elem.key]
      });
    }
  }

  shuffle(a) {
    var j, x, i;
    for (i = a.length - 1; i > 0; i--) {
        j = Math.floor(Math.random() * (i + 1));
        x = a[i];
        a[i] = a[j];
        a[j] = x;
    }
    return a;
  }

  reset(){
    this.setState({
      lang:"",
      quiz:"",
      ready:false,
      index:0,
      stack:[],
      selected:[]
    });
  }


  handleBack(e) {
    e.preventDefault();

    this.setState({
      index:this.state.index -1,
      selected:this.state.stack[this.state.index -1]
    });

  }

  handleChange(e){

    e.preventDefault();

    let lang = "";
    switch (e.target.value) {
      case "kor":
        this.setState({
          lang:"kor",
          quiz:this.shuffle(Kor.questions),
        });
        break;
      case "rus":
        this.setState({
          lang:"rus",
          quiz:this.shuffle(Rus.questions),
        });
        break;
      case "chn":
        this.setState({
          lang:"chn",
          quiz:this.shuffle(Chn.questions),
        });
        break;
      case "ger":
        this.setState({
          lang:"ger",
          quiz:this.shuffle(Ger.questions),
        });
        break;
      case "fra":
        this.setState({
          lang:"fra",
          quiz:this.shuffle(Fra.questions),
        });
        break;
      case "ita":
        this.setState({
          lang:"ita",
          quiz:this.shuffle(Ita.questions),
        });
        break;
      case "jap":
        this.setState({
          lang:"jap",
          quiz:this.shuffle(Jap.questions),
        });
        break;
      case "bra":
        this.setState({
          lang:"bra",
          quiz:this.shuffle(Bra.questions),
        });
        break;
      case "esp":
        this.setState({
          lang:"esp",
          quiz:this.shuffle(Esp.questions),
        });
        break;
      default:
        this.setState({
          lang:"en",
          quiz:this.shuffle(Eng.questions),
        });
    }
  }

  render() {

    return (

      <div id="App">
            {this.state.ready ?
              this.state.index === this.state.quiz.length ? (
                  <div id="Result-body">
                    {this.getScore() > config.limit ?
                      <h1>Congratulations!</h1>
                    : null
                    }
                    <h3>Your score:</h3>
                    <h1>{this.getScore()}</h1>
                    <p>Passing score:</p>
                    <p>{config.limit}</p>
                    <div id="Controls">
                        <button className="float btn" onClick={this.reset} >Try again</button>
                        {this.getScore() >= config.limit ?
                          <button className="float btn primary" onClick={() => {
                            window.location.href = "https://foryou.ericsson.com/coc-completion-form.html"
                          }} >Continue</button>
                          :
                          null
                        }
                    </div>
                  </div>
              ):(
                  <div>
                    <h3 id="Count">{this.state.index + 1}/{this.state.quiz.length}</h3>
                    <h1>{this.state.quiz[this.state.index].head}</h1>
                  {this.state.quiz[this.state.index].body.length > 10 ?(
                    <div id="AnswerBox" style={{columnCount:3, columnWidth:"100px"}}>
                        {this.state.quiz[this.state.index].body.map((item, key) => {
                          return(
                            <div className="Item" key={key} onClick={() => this.handleClick({key})} >
                              {this.state.selected.includes(key) ? (
                                <input type={this.state.quiz[this.state.index].type} name="answers" value={key} checked="checked" />
                              ) : (
                                <input type={this.state.quiz[this.state.index].type} name="answers" value={key} />
                              )}
                              {item.answer}
                            </div>
                          )
                        })}
                    </div>
                  ):(
                    <div id="AnswerBox">
                        {this.state.quiz[this.state.index].body.map((item, key) => {
                          return(
                            <div className="Item" key={key} onClick={() => this.handleClick({key})} >
                              {this.state.selected.includes(key) ? (
                                <input type={this.state.quiz[this.state.index].type} name="answers" value={key} checked="checked" />
                              ) : (
                                <input type={this.state.quiz[this.state.index].type} name="answers" value={key} />
                              )}
                              {item.answer}
                            </div>
                          )
                        })}
                    </div>
                  )}
                    <div id="Controls">
                        {this.state.index >= 1 ? (
                          <input className="float btn" type="button" onClick={this.handleBack} value="Back" />
                        ):(
                          null
                        )}
                        <input className="float btn primary" type="button" onClick={this.handleSubmit} value="Submit" />
                    </div>
                  </div>
              )
            : (
              <div>
                <div id="dropdown" className="light select" data-type="single">

                  <select className="options-list" onChange={this.handleChange}>
                    <option className="item" value="eng">English</option>
                    <option className="item" value="ger">German</option>
                    <option className="item" value="fra">French</option>
                    <option className="item" value="ita">Italian</option>
                    <option className="item" value="esp">Spanish</option>
                    <option className="item" value="bra">Portugese (Brazil)</option>
                    <option className="item" value="rus">Russian</option>
                    <option className="item" value="kor">Korean</option>
                    <option className="item" value="chn">Chinese</option>
                    <option className="item" value="jap">Japanese</option>
                  </select>
                </div>

                <button className="btn primary" onClick={this.start}>Start</button>
              </div>
            )}
      </div>
    );
  }
}
